import React, { useState, useEffect } from "react";
import NewsCard from "../../components/NewsCard";

const Updates = () => {
  const type = "updates";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [page, setPage] = useState(0);
  const pageSize = 16;
  const [items, setItems] = useState([]);

  const paginatedItems = items.slice(page * pageSize, (page + 1) * pageSize);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(`/content/${type}/index.json`);
        const data = await res.json();
        console.log("Loaded data", data);
        setItems(data);
      } catch (err) {
        console.error("Error loading JSON content:", err);
      }
    }
    load();
  }, [type]);

  if (isMobile) {
    return (
      <div>
        <div></div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="page-hero-text-wrapper">
        <div className="page-hero-text">Updates</div>
      </div>
      <div className="page-body-wrapper">
        <div className="news-page-body-wrapper">
          {paginatedItems
            .reduce((rows, item, index) => {
              if (index % 4 === 0) rows.push([]);
              rows[rows.length - 1].push(item);
              return rows;
            }, [])
            .map((row, rowIndex) => (
              <div className="news-page-cards-wrapper" key={rowIndex}>
                {row.map((item) => (
                  <div className="news-card-wrapper" key={item.filename}>
                    <NewsCard item={item} />
                  </div>
                ))}
              </div>
            ))}
        </div>
        <div className="news-page-pagination-wrapper">
          <div className="news-page-pagination">
            <div className="news-page-pagination">
              <button
                onClick={() => setPage((p) => Math.max(p - 1, 0))}
                disabled={page === 0}
                className="news-page-pagination-btn prev"
              />
              <button
                className="news-page-pagination-btn nxt"
                onClick={() =>
                  setPage((p) =>
                    (p + 1) * pageSize < items.length ? p + 1 : p
                  )
                }
                disabled={(page + 1) * pageSize >= items.length}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Updates;
